/** Cálculo de ahorro — sin inventar descuentos. */
export function computeAhorro(precioActual, precioAnterior) {
  const actual = Number(precioActual);
  const anterior = Number(precioAnterior);
  if (!Number.isFinite(actual) || !Number.isFinite(anterior)) return null;
  if (actual <= 0 || anterior <= 0) return null;
  if (anterior <= actual) return null;
  const monto = Math.round((anterior - actual) * 100) / 100;
  const pct = Math.round(((anterior - actual) / anterior) * 1000) / 10;
  return { monto, pct, precioAnterior: anterior, precioActual: actual };
}
